import { Component, OnInit, inject } from '@angular/core'
import { Router } from '@angular/router'

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
    private router = inject(Router);

    constructor() {
        this.router.navigateByUrl('manage-saleyard-auction/home')
    }

    ngOnInit(): void {}
}
